import { useMemo } from "react";

import { type CategoricalBreakdownConfig } from "@north-beam/nb-common";

import { type TileFilter } from "../types";

export const useBreakdownDeactivatedCheck = (
  breakdowns: string[] | undefined,
  filters: TileFilter[] | undefined,
  breakdownConfigs: CategoricalBreakdownConfig[],
) => {
  return useMemo(() => {
    let deactivated = false;

    if (!breakdowns) {
      return deactivated;
    }

    if (!filters) {
      return deactivated;
    }

    const breakdownConfigKeys = breakdownConfigs.map((e) => e.key);
    const filterBreakdowns = filters.map((e) => e.breakdown);

    for (const key of [...breakdowns, ...filterBreakdowns]) {
      if (!breakdownConfigKeys.includes(key)) {
        deactivated = true;
        break;
      }
    }

    return deactivated;
  }, [breakdowns, filters, breakdownConfigs]);
};
